import 'react-image-gallery/styles/css/image-gallery.css';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ImageGallery from 'react-image-gallery';
import UiDialogTitle from 'ui-components/ui-dialog-title/UiDialogTitle';
import UiDialogContent from 'ui-components/ui-dialog-content/UiDialogContent';
import UiIcon from 'ui-components/ui-icon/UiIcon';
import { StyledMediaGalleryDialog } from './MediaGallery.styles';

const MediaGallery = ({ children, title, media = [] }) => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  const closeDialog = () => {
    setVisible(false);
  };

  //   نرمال کردن ویدیو ها
  const _media = media.map((x) => {
    x['srcSet'] = x?.original;
    if (typeof x?.srcSet !== 'string') {
      return {
        original: x?.original,
        thumbnail: x?.thumbnail?.poster,
        embedUrl: x?.embedUrl,
        // eslint-disable-next-line react/display-name
        renderThumbInner: (item) => {
          return (
            <span className='image-gallery-thumbnail-inner'>
              <UiIcon icon='ri-play-circle-fill' />
              <img
                className='image-gallery-thumbnail-image'
                src={item?.thumbnail}
              />
            </span>
          );
        },
        // eslint-disable-next-line react/display-name
        renderItem: (item) => {
          return (
            <div className='video-wrapper'>
              <video
                style={{ width: 'auto', maxWidth: '400px' }}
                poster={item?.original?.poster}
                controls
                muted
                controlsList='nodownload'
                src={item?.embedUrl}
                preload='none'
              >
                <source
                  src={item?.original?.video}
                  type={item?.original?.type}
                />
              </video>
            </div>
          );
        },
      };
    }

    return x;
  });
  return (
    <>
      {children(setVisible)}
      <StyledMediaGalleryDialog
        open={visible}
        className='media-gallery-dialog'
        onClose={closeDialog}
      >
        <UiDialogTitle>
          <div>{title || t('content:contentGallery')}</div>
          <div>
            <UiIcon
              className='close-icon'
              icon='ri-close-line'
              onClick={() => setVisible((x) => !x)}
            />
          </div>
        </UiDialogTitle>
        <UiDialogContent>
          <ImageGallery
            items={_media}
            isRTL
            showNav={false}
            showPlayButton={false}
          />
        </UiDialogContent>
      </StyledMediaGalleryDialog>
    </>
  );
};

MediaGallery.propTypes = {
  title: PropTypes.string,
  media: PropTypes.array,
  children: PropTypes.any,
};

export default MediaGallery;
